/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { replaceScriptNodes } from "../../utils";
import { ErrorBoundary } from "../error-boundary";
import { PropTypes } from "prop-types";

import "./widget.module.css";

export class WidgetComponent extends React.Component {
  constructor(props) {
    super(props);
    this.widgetSlot = React.createRef();
  }
  componentDidMount = () => {
    const currentNode = this.widgetSlot.current;
    currentNode && replaceScriptNodes(currentNode);
  };
  render() {
    return (
      <ErrorBoundary>
        <div
          styleName="widgetWrapper"
          ref={this.widgetSlot}
          dangerouslySetInnerHTML={{ __html: this.props.widgetValue }}
        />
      </ErrorBoundary>
    );
  }
}

WidgetComponent.propTypes = {
  widgetValue: PropTypes.string
};
